import React, { Component } from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import store from '../../../store'
import style from './index.module.less'
import cls from 'classnames'
import { EditOutlined, SwapOutlined } from '@ant-design/icons'
import { Tooltip } from 'hljd'
import { observer } from 'mobx-react'
import { isSiDaMember } from '@util'
import {
  MENU_ALL,
  MENU_NOT_CLASSIFY
} from '@components/LocalMerchant/Case/constant'

const itemSource = {
  beginDrag(props) {
    return {
      index: props.index
    }
  }
}

const itemTarget = {
  hover(props, monitor) {
    const dragIndex = monitor.getItem().index

    const hoverIndex = props.index
    if (dragIndex === hoverIndex) {
      return
    }

    monitor.getItem().index = hoverIndex
    store.moveMenu(dragIndex, hoverIndex)
  },
  drop() {
    store.menuListSort()
  }
}

@observer
class MenuItem extends Component {
  getDom = (merchant_category_id, isSort) => {
    const { item, isDragging } = this.props
    const showIcon =
      !isSort &&
      item.id != MENU_ALL &&
      item.id != MENU_NOT_CLASSIFY &&
      !isSiDaMember()
    const canEdit =
      item.id != MENU_ALL && item.id != MENU_NOT_CLASSIFY && !isSiDaMember()
    return (
      <li
        className={cls(
          style.menuItem,
          merchant_category_id == item.id ? style.active : ''
        )}
        style={{
          opacity: isDragging ? '0.8' : 1
          // background: isDragging ? '#F6F6F7' : '#FFFFFF'
        }}
        onClick={() =>
          store.beforeOnChange('merchant_category_id', item.id, true)
        }
      >
        {showIcon ? (
          <Tooltip placement="topLeft" title="拖动整行排序">
            <SwapOutlined className={style.swap} />
          </Tooltip>
        ) : (
          <span style={{ padding: '0 10px' }} />
        )}
        {`${item.title}(${item.itemCount || 0})`}
        {canEdit && (
          <EditOutlined
            className={style.edit}
            onClick={e => this.props.editCaseCate(e, item)}
          />
        )}
      </li>
    )
  }
  render() {
    const { connectDragSource, connectDropTarget, canSort } = this.props
    const { merchant_category_id, isSort } = store
    if (canSort) {
      return connectDragSource(
        connectDropTarget(this.getDom(merchant_category_id, isSort))
      )
    } else {
      return this.getDom(merchant_category_id, isSort)
    }
  }
}

export const DragableItem = DropTarget(
  'item',
  itemTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  })
)(
  DragSource('item', itemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))(MenuItem)
)

export default MenuItem
